import React, { useCallback, useEffect, useState } from "react";
import ModalModern from "../ModalModern";
import ModernPopupHeader from "../common/ModernPopupHeader";
import ModernPopupBody from "../common/ModernPopupBody";
import LoadingPlaceholder from "../../loading/LoadingPlaceholder";
import { getSpendingHeavyHitterTransactions } from "../../../../api/finances/spendingsAPI";
import { getInitialsIconSrc } from "../../../../utils/images/iconUtils";
import TransactionRowCard from "../../cards/finances/TransactionRowCard";

function SpendingTransactionModal({ title, category, onClose }) {
  const [loadingTransactions, setLoadingTransactions] = useState(true);
  const [transactionsError, setTransactionsError] = useState("");
  const [transactions, setTransactions] = useState([]);

  const getTransactionIconSrc = (transaction) =>
    transaction.logo_url || getInitialsIconSrc(transaction.merchant);

  const loadTransactions = useCallback(async () => {
    setLoadingTransactions(true);
    setTransactionsError("");

    try {
      const data = await getSpendingHeavyHitterTransactions(category);
      setTransactions(data?.transactions || []);
    } catch (err) {
      setTransactions([]);
      setTransactionsError(
        "We could not load transactions for this category. Please try again.",
      );
    } finally {
      setLoadingTransactions(false);
    }
  }, [category]);

  useEffect(() => {
    loadTransactions();
  }, [loadTransactions]);

  return (
    <ModalModern onClose={onClose}>
      <ModernPopupHeader onClose={onClose}>
        <div
          className="header-content-modern-row"
          style={{
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <h3 className="transaction-popup-title" style={{ margin: 0 }}>
            {title}
          </h3>
        </div>
      </ModernPopupHeader>

      <ModernPopupBody>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {loadingTransactions ? (
            // Show skeleton lines while loading
            <div style={{ padding: "10px 0" }}>
              <LoadingPlaceholder type="line" rows={4} />
            </div>
          ) : transactionsError ? (
            <span style={{ fontSize: "14px", color: "#6B7280" }}>
              {transactionsError}
            </span>
          ) : (
            transactions.map((t, index) => (
              <TransactionRowCard
                key={t.id || index}
                transaction={t}
                showBorder={index !== transactions.length - 1}
                getTransactionIconSrc={getTransactionIconSrc}
              />
            ))
          )}
        </div>
      </ModernPopupBody>
    </ModalModern>
  );
}

export default SpendingTransactionModal;
